import { Button, Typography } from 'antd';
import React, { ReactElement } from 'react';
import Layout from './Layout';

export default function LoansPoolCut(): ReactElement {
    return (
        <Layout section='loans-pool-cut'>
            <Typography.Title level={2}>Loans Pool Cut Report</Typography.Title>
            <Button
                href={`${process.env.API_HOST}/loans/download-loan-book-report`}
                target='_blank'
                type='primary'
            >Download</Button>
        </Layout>
    );
}
